import { OrderStatus } from 'enums';

// Spread onto any element whose content must never appear in Clarity session recordings.
export const CLARITY_MASK_PROPS = { 'data-clarity-mask': 'true' } as const;

// Deeplink orders often redirect away at once; delaying the start keeps those out of the recordings.
export const CLARITY_START_DELAY_MS = 2000;

// Deliberately neutral: the channel name is observable, so it must not hint at session recording.
export const CLARITY_TABS_CHANNEL_NAME = 'sp-order-tabs';

export const FINAL_ORDER_STATUSES = [
  OrderStatus.Completed,
  OrderStatus.HoldCompleted,
  OrderStatus.Cancelled,
  OrderStatus.Error,
];
